import makerjs, {IMeasureWithCenter, IModel} from 'makerjs';
import Length from "../../../source/js/shared/models/Geometry/Length";
import DrillHole from "./DrillHole";
import OffsetLine from './Lines/OffsetLine';
import { renderLength } from '@/functions/lengths';

export default class GridDrillHoles {
	diameter: Length;
	offset: Length;
	horizontalAmount: number;
	verticalAmount: number;
	enclosingRectangle: IMeasureWithCenter;

	constructor( diameter: Length, offset: Length, horizontalAmount: number, verticalAmount: number, enclosingRectangle: IMeasureWithCenter ) {
		this.diameter = diameter;
		this.offset = offset;
		this.horizontalAmount = horizontalAmount;
		this.verticalAmount = verticalAmount;
		this.enclosingRectangle = enclosingRectangle;
	}

	getId(): string {
		return 'grid-drillHoles';
	}

	getPath(): MakerJs.paths.Circle {
		return new DrillHole( this.offset, this.offset, this.diameter ).getPath();
	}

	cloneToGrid(): IModel {
		const { width, height } = this.enclosingRectangle;

		return makerjs.layout.cloneToGrid(
			this.getPath(),
			this.horizontalAmount,
			this.verticalAmount,
			[
				this.calculateGridSpacing( width, this.offset.in_cm(), this.diameter.in_cm(), this.horizontalAmount ),
				this.calculateGridSpacing( height, this.offset.in_cm(), this.diameter.in_cm(), this.verticalAmount ),
			]
		);
	}

	calculateGridSpacing( size: number, offset: number, diameter: number, length: number ): number {
		const workArea = ( size - ( offset * 2 ) ) + this.diameter.in_cm();
		const spaceToUse = ( length > 1 ) ? length - 1 : 1;

		return ( workArea - ( length * diameter ) ) / spaceToUse;
	}

	getAsModel(): IModel {
		let grid = {};

		if ( this.horizontalAmount > 0 && this.verticalAmount > 0 ) {
			grid = this.cloneToGrid();
		}

		grid[ 'type' ] = 'grid-drillHole';

		makerjs.model.zero(grid);
		makerjs.model.move(grid, [ this.offset.in_cm(), this.offset.in_cm() ]);
		makerjs.model.moveRelative(grid, [ this.enclosingRectangle.low[ 0 ], this.enclosingRectangle.low[ 1 ] ]);

		return grid;
	}

	getOffsetLines(focusedElement = ''): OffsetLine[] {
		if(focusedElement.includes('drillHoleOffset')) {
			return [
				new OffsetLine(
					[ this.offset.in_mm(), 0 ],
					[ this.offset.in_mm(), this.offset.in_mm() ],
					renderLength(this.offset.in_cm())
				),
			];
		}

		return [];
	}
}
